import React from 'react';

export const ShareButton = ({ label, hideIcon, onClick, fill = 'white' }) => {
  const handleButtonClick = (e) => {
    e.preventDefault();

    if(onClick) {
      onClick(e);
    }
  }
  
  return (
    <div
      className={`shareButton__container`}
      onClick={handleButtonClick}
    >
      <span className={`shareButton__label`}>{label}</span>
      {!hideIcon && (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.999" height="15" viewBox="0 0 19.999 15">
          <g id="share-icon" transform="translate(0 0)">
            <path id="Path_782" data-name="Path 782" fill={fill} d="M23.785-11.155A8.287,8.287,0,0,0,20.7-9.13,14.53,14.53,0,0,0,19-7.042v-8.228a14.535,14.535,0,0,0,1.7,2.088,8.289,8.289,0,0,0,3.083,2.025" transform="translate(-3.785 18.757)"/>
            <path id="Path_784" data-name="Path 784" fill={fill} d="M4-9.01H15.764v-1.259H4Z" transform="translate(2.035 17.259)"/>
            <path id="Path_785" data-name="Path 785" fill={fill} d="M11.826,14H0V-1H11.826V3.662H10.485V.282H1.342V12.718h9.143V9.287h1.342Z" transform="translate(0 1)"/>
          </g>
        </svg>
      )}
    </div>
  );
}
